import React from "react";
import Topbar from "../constant/Topbar/Topbar";

const SimpleLayout = ({ children }) => {
  return (
    <div style={{ background: "#E5E5E5" }}>
      <Topbar />

      <div style={{ marginTop: 20, marginLeft: 30 }}>{children}</div>
    </div>
  );
};

export default SimpleLayout;
